import { useCallback, useState } from 'react'
import Project from 'common/project'
import _data from 'common/utils/_data'

interface Author {
  id: number
  name: string
  role: string
  email: string
}

interface LegalDocument {
  id: number
  author: Author
  version: string
  created_at: string
  updated_at: string
  uuid: string
  slug: string
  title: string
  summary: string
  content: string
  publish_date: string
  update_date: string
  review_date: string
}

export const useLegal = () => {
  const [isLoading, setLoading] = useState<boolean>(false)
  const [legalDoc, setLegalDoc] = useState<LegalDocument | null>(null)

  const getLegal = useCallback(async (slug: string) => {
    try {
      setLoading(true)
      const data = await _data.get(
        `${Project.liveApi}website/legal-page/terms-and-policies/${slug}/`,
      )
      setLegalDoc(data)
    } catch (error) {
      console.error('Failed to fetch legal document:', error)
      setLegalDoc(null)
    } finally {
      setLoading(false)
    }
  }, [])

  return {
    getLegal,
    legalDoc,
    isLoading,
  }
}
